import React, { memo, useCallback } from 'react';
import { useTranslation } from "react-i18next";
import FilterListIcon from '@mui/icons-material/FilterList';
import TemporaryDrawer from "../Drawer/Drawer";
import { Filtruoti } from "../filtruoti";
import { FiltruChipai } from "../FiltruChipai";
import { Rodoma } from './Rodoma.optimized';

// Optimizuotas FilterHeader komponentas su useMemo ir useCallback funkcijomis
const FilterHeader = memo(({ 
    filtersMain, 
    setFilterMain, 
    companies, 
    user, 
    clearParam, 
    drawer,
    setDrawer,
}) => {
    const { t } = useTranslation();
    
    // Filtro atnaujinimo funkcija - naudojame useCallback optimizacijai
    const handleFilterUpdate = useCallback((newFilters) => {
        // Tiesiogiai perduodame filtrus be papildomų veiksmų
        setFilterMain(newFilters);
    }, [setFilterMain]);

    return (
        <div className="standartPadding sticky">
            <div className="row spaceBetween sticky">
                <Rodoma
                    setFilter={handleFilterUpdate}
                    filters={filtersMain}
                    companies={companies}
                    user={user}
                    clearParam={clearParam}
                    // isLoading={isLoading}
                />
                
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    {/* {(isLoading) && (
                        <div style={{ display: 'flex', alignItems: 'center', marginRight: '12px' }}>
                            <CircularProgress 
                                size={18} 
                                thickness={5} 
                                sx={{ 
                                    color: '#0066CC',
                                    marginRight: '8px',
                                    opacity: 0.8
                                }} 
                            />
                            <span style={{ fontSize: '14px', color: '#0066CC', fontWeight: 'normal' }}>
                                {t('Atnaujinama...')}
                            </span>
                        </div>
                    )} */}
                    
                    <TemporaryDrawer
                        className={'drawer right'}
                        classNameBtn={'copyBtn filtrasBtn'}
                        side={'right'}
                        text={t('filtruoti')}
                        endIcon={<FilterListIcon />}
                        on={drawer}
                        setOn={setDrawer}
                        elements={
                            <div className="filterDrawer filterPadding">
                                <Filtruoti setOn={setDrawer} />
                            </div>
                        }
                    />
                </div>
            </div>
            <FiltruChipai />
        </div>
    );
});

// Pridedam displayName geresniam debugginimui
FilterHeader.displayName = 'FilterHeader';

export default FilterHeader;
